module.exports = __webpack_public_path__ + "img/115.eadb1616.jpg";